
import { CloseIcon } from '@chakra-ui/icons';
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  IconButton,
  Select,
  Text,
  Tooltip,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { CalibrationRecord, calibrationRecordRepository } from 'api/calibrationRecord';
import Card from 'components/card/Card';
import InputField from 'components/fields/InputField';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { contactEmailSchema, contactNumberSchema, nameSchema } from 'validations/Validations';
import { CertificateRepository } from 'api/CertificateRepository';
//import { getCalibrationHistoryByAssetId } from 'api/assetDetailRepository';

type FormState = {
  calibrationId: string;
  orgId: string;
  locationId: string;
  assetId: string;
  assetEquipmentId: string;
  vendorId: string;
  departmentId: string;
  organizationName: string;
  locationName: string;
  vendorName: string;
  assetName: string;
  contactName: string;
  contactEmail: string;
  contactNumber: string;
  calibrationFrequency: string;
  customFrequency: string;
  departmentName: string;
  calibrationDate: string;
  calibrationDueDate: string;
  priority: string;
  daysToExpire: string;
  // status: string;
  noOfCertificates: string;
};

export default function NewRecord() {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const inputBg = useColorModeValue('white', 'navy.700');
  const inputBorderColor = useColorModeValue('gray.200', 'whiteAlpha.300');
  const menuListBg = useColorModeValue('white', 'navy.800');

  const navigate = useNavigate();
  const location = useLocation();

  const search = new URLSearchParams(location.search);
  const editingId = search.get('id') ?? '';

  const assetFromState = (location.state as any)?.asset;
  const [isEditMode, setIsEditMode] = useState<boolean>(!!editingId);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const [form, setForm] = useState<FormState>({
    calibrationId: editingId || '',
    orgId: assetFromState?.orgId || '',
    locationId: assetFromState?.locationId || '',
    assetId: assetFromState?.assetId || '',
    vendorId: assetFromState?.vendorId || '',
    departmentId: assetFromState?.departmentId || '',
    assetEquipmentId: '',
    organizationName: '',
    locationName: '',
    vendorName: '',
    assetName: '',
    contactName: '',
    contactEmail: '',
    contactNumber: '',
    calibrationFrequency: 'Monthly',
    customFrequency: '',
    departmentName: '',
    calibrationDate: today,
    calibrationDueDate: '',
    
      
     
    priority: 'High',
    daysToExpire: '',
    // status: '',
  noOfCertificates: '5',
  });

  const [headerContext, setHeaderContext] = useState<any>(null);

  const [centerAlertVisible, setCenterAlertVisible] = useState(false);
  const [centerAlertMessage, setCenterAlertMessage] = useState('');
  const [centerAlertStatus, setCenterAlertStatus] = useState<
    'success' | 'info' | 'warning' | 'error'
  >('success');
  const centerAlertTimerRef = useRef<number | null>(null);

  const [errors, setErrors] = useState<Record<string, string>>({});

  const renderTextWithTooltip = (label: string, value: string | undefined, maxLength = 10) => {
    if (!value) value = '-';
    const isLong = value.length > maxLength;
    const displayValue = isLong ? value.slice(0, maxLength) + '...' : value;

    return (
      <Tooltip label={isLong ? value : undefined} hasArrow placement="top">
        <Text fontSize="sm" noOfLines={1} maxW="160px">
          {label}: {displayValue}
        </Text>
      </Tooltip>
    );
  };

  useEffect(() => {
    if (form.calibrationDueDate) {
      const today = new Date();
      const dueDate = new Date(form.calibrationDueDate);

      if (!isNaN(dueDate.getTime())) {
        const todayUTC = Date.UTC(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );

        const dueUTC = Date.UTC(
          dueDate.getFullYear(),
          dueDate.getMonth(),
          dueDate.getDate()
        );

        const diffDays = Math.ceil(
          (dueUTC - todayUTC) / (1000 * 60 * 60 * 24)
        );

        setForm((prev) => ({
          ...prev,
          daysToExpire: diffDays.toString(),
        }));
      }
    } else {
      setForm((prev) => ({
        ...prev,
        daysToExpire: '',
      }));
    }
  }, [form.calibrationDueDate]);

  useEffect(() => {
    if (form.orgId || form.locationId || form.assetId || form.vendorId || form.departmentId) {
      calibrationRecordRepository
        .getHeaderContext(form.orgId, form.locationId, form.assetId, form.vendorId, form.departmentId)
        .then((data) => setHeaderContext(data))
        .catch(() => setHeaderContext(null));
    }
  }, [form.orgId, form.locationId, form.assetId, form.vendorId, form.departmentId]);

  useEffect(() => {
    if (headerContext?.assetInfo?.assetEquipmentId) {
      setForm(prev => ({
        ...prev,
        assetEquipmentId: headerContext.assetInfo.assetEquipmentId
      }));
    }
  }, [headerContext]);
  useEffect(() => {
    if (headerContext?.vendorInfo?.contactEmail) {
      setForm((prev) => ({
        ...prev,
        contactEmail: headerContext.vendorInfo.contactEmail
      }));
    }
  }, [headerContext]);

  useEffect(() => {
    if (isEditMode && editingId) {
      calibrationRecordRepository
        .getRecordById(editingId)
        .then((record) => {
          if (record) {
            setForm((prev) => ({
              ...prev,
              ...record,
              calibrationDate: record.calibrationDate
                ? record.calibrationDate.split('T')[0]
                : '',
              calibrationDueDate: record.calibrationDueDate
                ? record.calibrationDueDate.split('T')[0]
                : '',
            
              calibrationId: record.calibrationId ?? editingId,
              daysToExpire:
                record.daysToExpire !== undefined && record.daysToExpire !== null
                  ? record.daysToExpire.toString()
                  : '',
              noOfCertificates:
                record.noOfCertificates !== undefined &&
                record.noOfCertificates !== null
                  ? record.noOfCertificates.toString()
                  : '',
            }));
          }
        }).catch((err) => {
        });
    }
  }, [isEditMode, editingId, ]);
//   useEffect(() => {
//   const loadCertificateCount = async () => {
//     if (!form.assetId) return;

//     try {
//       const history = await getCalibrationHistoryByAssetId(form.assetId);

//       if (!history || history.length === 0) return;

//       const getHistoryTimestamp = (item: any) => {
//         return new Date(
//           item.calibratedDate ||
//           item.createdAt ||
//           item.calibrationDate ||
//           item.calibrationDueDate ||
//           ''
//         ).getTime();
//       };

//       const latestHistory = [...history]
//         .filter((h) => h.certificateId)
//         .sort(
//           (a, b) =>
//             getHistoryTimestamp(b) -
//             getHistoryTimestamp(a)
//         )[0];

//       if (!latestHistory?.certificateId) return;

//       const certificateResponse =
//         await CertificateRepository.getAllCertificate(0, 10000);

//       const certificate = certificateResponse.data.find(
//         (c) =>
//           c.certificateId === latestHistory.certificateId
//       );

//       const count = Array.isArray(certificate?.certificates)
//         ? certificate.certificates.length
//         : 0;

//       setForm((prev) => ({
//         ...prev,
//         noOfCertificates: count.toString(),
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   if (!isEditMode) {
//     loadCertificateCount();
//   }
// }, [form.assetId, isEditMode]);


  const validateField = (id: string, value: string) => {
    try {
      switch (id) {
        case 'contactName': {
          const schema = nameSchema('Contact Name');
          const result = schema.safeParse(value);
          if (!result.success) {
            setErrors((prev) => ({ ...prev, [id]: result.error.issues[0].message }));
            return;
          }
          break;
        }
        case 'contactEmail': {
          const result = contactEmailSchema.safeParse(value);
          if (!result.success) {
            setErrors((prev) => ({ ...prev, [id]: result.error.issues[0].message }));
            return;
          }
          break;
        }
        case 'contactNumber': {
          const result = contactNumberSchema.safeParse(value);
          if (!result.success) {
            setErrors((prev) => ({ ...prev, [id]: result.error.issues[0].message }));
            return;
          }
          break;
        }
        case 'calibrationDate':
        case 'calibrationDueDate': {
          if (form.calibrationDate && form.calibrationDueDate) {
            const s = new Date(id === 'calibrationDate' ? value : form.calibrationDate);
            const e = new Date(id === 'calibrationDueDate' ? value : form.calibrationDueDate);
            if (!isNaN(s.getTime()) && !isNaN(e.getTime())) {
              const startUTC = Date.UTC(s.getFullYear(), s.getMonth(), s.getDate());
              const endUTC = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());
              if (endUTC < startUTC) {
                setErrors((prev) => ({
                  ...prev,
                  calibrationDueDate: 'Due date must be the same or after calibration date.',
                }));
                return;
              } else {
                setErrors((prev) => {
                  const copy = { ...prev };
                  delete copy.calibrationDate;
                  delete copy.calibrationDueDate;
                  return copy;
                });
              }
            }
          }
          break;
        }
        default:
          break;
      }

      setErrors((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
    } catch (err) {
      setErrors((prev) => ({ ...prev, [id]: 'Invalid value' }));
    }
  };
const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
) => {
  const { id, value } = e.target;

if (id === "noOfCertificates") {
  const num = Number(value);

  if (value !== "" && (num < 0 || num > 10)) {
    return;
  }

  setForm((prev) => ({
    ...prev,
    noOfCertificates: value,
  }));

  return;
}

  if (id === "calibrationFrequency" && value !== "Custom") {
    setForm((prev) => ({
      ...prev,
      calibrationFrequency: value,
      customFrequency: "",
    }));
    return;
  }

  setForm((prev) => ({ ...prev, [id]: value }));
  validateField(id, value);
};
  const buildPayload = (): Partial<CalibrationRecord> => {
    return {
      ...form,
      assetId: form.assetId || headerContext?.assetInfo?.id || '',
      orgId: form.orgId || headerContext?.orgInfo?.id || '',
      locationId: form.locationId || headerContext?.locationInfo?.id || '',
      vendorId: form.vendorId || headerContext?.vendorInfo?.id || '',
      departmentId: form.departmentId || headerContext?.departmentInfo?.id || '',
      organizationName: form.organizationName || headerContext?.orgInfo?.name || '',
      locationName: form.locationName || headerContext?.locationInfo?.name || '',
      vendorName: form.vendorName || headerContext?.vendorInfo?.name || '',
      assetName: form.assetName || headerContext?.assetInfo?.name || '',
      departmentName: form.departmentName || headerContext?.departmentInfo?.name || '',
      daysToExpire: form.daysToExpire ? Number(form.daysToExpire) : undefined,
      noOfCertificates: form.noOfCertificates
        ? Number(form.noOfCertificates)
        : undefined,
  
      assetEquipmentId:
        form.assetEquipmentId || headerContext?.assetInfo?.assetEquipmentId || '',

    };
  };

  const validateBeforeSubmit = (): boolean => {
    const validationErrors: Record<string, string> = { ...errors };

    const nameRes = nameSchema('Contact Name').safeParse(form.contactName);
    if (!nameRes.success) validationErrors['contactName'] = nameRes.error.issues[0].message;

    const emailRes = contactEmailSchema.safeParse(form.contactEmail);
    if (!emailRes.success) validationErrors['contactEmail'] = emailRes.error.issues[0].message;

    const phoneRes = contactNumberSchema.safeParse(form.contactNumber);
    if (!phoneRes.success) validationErrors['contactNumber'] = phoneRes.error.issues[0].message;

    if (form.calibrationDate && form.calibrationDueDate) {
      const s = new Date(form.calibrationDate);
      const e = new Date(form.calibrationDueDate);
      if (!isNaN(s.getTime()) && !isNaN(e.getTime())) {
        const startUTC = Date.UTC(s.getFullYear(), s.getMonth(), s.getDate());
        const endUTC = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());
        if (endUTC < startUTC) {
          validationErrors['calibrationDueDate'] = 'Due date must be the same or after calibration date.';
        }
      }
    }
    setErrors(validationErrors);

    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    if (!validateBeforeSubmit()) {
      setCenterAlertStatus('error');
      setCenterAlertMessage('Please fix validation errors before submitting.');
      setCenterAlertVisible(true);
      if (centerAlertTimerRef.current) clearTimeout(centerAlertTimerRef.current);
      centerAlertTimerRef.current = window.setTimeout(() => setCenterAlertVisible(false), 2500);
      setIsSubmitting(false);
      return;
    }

    try {
      const payload = buildPayload();

      if (isEditMode && form.calibrationId) {
        await calibrationRecordRepository.updateRecord(form.calibrationId, payload);
        setCenterAlertStatus('success');
        setCenterAlertMessage('Record Updated Successfully');
      } else {
        await calibrationRecordRepository.addRecord(payload);
        setCenterAlertStatus('success');
        setCenterAlertMessage('Record Saved Successfully');
      }

      setCenterAlertVisible(true);
      if (centerAlertTimerRef.current) clearTimeout(centerAlertTimerRef.current);
      centerAlertTimerRef.current = window.setTimeout(() => setCenterAlertVisible(false), 2500);

      setTimeout(() => {
        navigate('/admin/Calibration/calibrationRecord');
      }, 1200);
    } catch (err) {
      setCenterAlertStatus('error');
      setCenterAlertMessage('Failed to save record');
      setCenterAlertVisible(true);
      if (centerAlertTimerRef.current) clearTimeout(centerAlertTimerRef.current);
      centerAlertTimerRef.current = window.setTimeout(() => setCenterAlertVisible(false), 2500);
    }
    finally {
      setIsSubmitting(false);
    }
  };
  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setForm({
      calibrationId: '',
      orgId: assetFromState?.orgId || '',
      locationId: assetFromState?.locationId || '',
      assetId: assetFromState?.assetId || '',
      vendorId: assetFromState?.vendorId || '',
      departmentId: assetFromState?.departmentId || '',
      assetEquipmentId: '',
      organizationName: '',
      locationName: '',
      vendorName: '',
      assetName: '',
      contactName: '',
      contactEmail: '',
      contactNumber: '',
      calibrationFrequency: 'Monthly',
      customFrequency: '',
      departmentName: '',
      calibrationDate: today,
      calibrationDueDate: '',
      priority: 'High',
      daysToExpire: '',
    
      // status: '',
    noOfCertificates: '',
  });
    setHeaderContext(null);
    setErrors({});
  };

  const handleClose = () => {
    if (isEditMode) {
      navigate('/admin/Calibration/calibrationRecord');
    } else {
      navigate('/admin/asset-management/assetList');
    }
  };

  return (
    <Flex direction="column" height="100vh" overflow="hidden" align="center" justify="flex-start" position="relative">

      {centerAlertVisible && (
        <Center
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          zIndex={60}
          pointerEvents="none"
        >
          <Alert
            status={centerAlertStatus}
            variant="solid"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            width="600px"
            borderRadius="14px"
            boxShadow="xl"
            py={10}
            px={16}
            pointerEvents="auto"
          >
            <AlertIcon boxSize="40px" mr={0} />

            <Text fontSize="lg" fontWeight="700" mt={1}>
              {centerAlertMessage}
            </Text>
          </Alert>
        </Center>
      )}

      <Box position="absolute" top="90" left="0" w="100%" h="40vh" bgGradient="linear(to-b, brand.400, brand.600)" borderRadius="20px" />

      <Box w={{ sm: '330px', md: '700px', lg: '900px' }} mt={{ md: '120px' }} mb="20px" zIndex={2}>
        <Grid templateColumns="repeat(5, 1fr)" gap="20px">
          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue('white', 'gray.700')} shadow="md" align="start" h="150px" w="100%">
            <Text fontWeight="bold" textAlign="center" w="100%">Organization</Text>
            {renderTextWithTooltip('Name', headerContext?.orgInfo?.name)}
            {renderTextWithTooltip('Contact', headerContext?.orgInfo?.contact)}
            {renderTextWithTooltip('GSTIN', headerContext?.orgInfo?.gsTin)}
          </VStack>

          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue('white', 'gray.700')} shadow="md" align="start" h="150px" w="100%">
            <Text fontWeight="bold" textAlign="center" w="100%">Plant</Text>
            {renderTextWithTooltip('Name', headerContext?.locationInfo?.name)}
            {renderTextWithTooltip('City', headerContext?.locationInfo?.city)}
            {renderTextWithTooltip('State', headerContext?.locationInfo?.state)}
          </VStack>

          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue('white', 'gray.700')} shadow="md" align="start" h="150px" w="100%">
            <Text fontWeight="bold" textAlign="center" w="100%">Asset</Text>
            {/* {renderTextWithTooltip('Name', headerContext?.assetInfo?.name)} */}
            {renderTextWithTooltip('EQ.ID', headerContext?.assetInfo?.assetEquipmentId)}
            {renderTextWithTooltip('Type', headerContext?.assetInfo?.type)}
            {renderTextWithTooltip('Status', headerContext?.assetInfo?.status)}
          </VStack>


          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue('white', 'gray.700')} shadow="md" align="start" h="150px" w="100%">
            <Text fontWeight="bold" textAlign="center" w="100%">Vendor</Text>
            {renderTextWithTooltip('Name', headerContext?.vendorInfo?.name)}
            {renderTextWithTooltip('Contact', headerContext?.vendorInfo?.contactNumber)}
            {renderTextWithTooltip('GSTIN', headerContext?.vendorInfo?.gsTin)}
          </VStack>


          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue('white', 'gray.700')} shadow="md" align="start" h="150px" w="100%">
            <Text fontWeight="bold" textAlign="center" w="100%">Department</Text>
            {renderTextWithTooltip('Name', headerContext?.departmentInfo?.name)}
          </VStack>
        </Grid>
      </Box>


      <Card w={{ sm: '330px', md: '700px', lg: '900px' }} p="30px" mt={{ md: '20px' }} zIndex={1} overflowY="auto" borderRadius="16px" position="relative">
        <IconButton icon={<CloseIcon />} aria-label="Close" position="absolute" top="10px" right="10px" size="sm" onClick={handleClose} />

        <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px" textAlign="left">
          {isEditMode ? 'Edit Calibration Record' : 'Add Calibration Record'}
        </Text>

        <form onSubmit={handleSubmit}>
          <Grid templateColumns="repeat(2, 1fr)" gap={6}>
            <FormControl isInvalid={!!errors.contactName}>
              <InputField label="Contact Name" id="contactName" value={form.contactName} onChange={handleChange} inputProps={{ style: { fontFamily: 'inherit' } }} />
              {errors.contactName && <FormErrorMessage>{errors.contactName}</FormErrorMessage>}
            </FormControl>

            <FormControl isInvalid={!!errors.contactEmail}>
              <InputField label="Contact Email" id="contactEmail" value={form.contactEmail} isReadOnly inputProps={{ style: { fontFamily: 'inherit' } }} />
              {errors.contactEmail && <FormErrorMessage>{errors.contactEmail}</FormErrorMessage>}
            </FormControl>

            <FormControl isInvalid={!!errors.contactNumber}>
              <InputField label="Contact Number" id="contactNumber" value={form.contactNumber} onChange={handleChange} inputProps={{ style: { fontFamily: 'inherit' } }} />
              {errors.contactNumber && <FormErrorMessage>{errors.contactNumber}</FormErrorMessage>}
            </FormControl>

           <FormControl isInvalid={!!errors.priority}>
              <Text fontSize={'sm'} mb="8px" fontWeight="Bold">Priority</Text>
              <Select
                id="priority"
                value={form.priority}
                onChange={handleChange}
                placeholder="Select Priority"
                bg={inputBg}
                color={textColor}
                borderColor={inputBorderColor}
              >
                <option style={{ backgroundColor: menuListBg, color: textColor }} value="High">High</option>
                <option style={{ backgroundColor: menuListBg, color: textColor }} value="Medium">Medium</option>
                <option style={{ backgroundColor: menuListBg, color: textColor }} value="Low">Low</option>
              </Select>
              {errors.priority && <FormErrorMessage>{errors.priority}</FormErrorMessage>}
            </FormControl>

            <FormControl isInvalid={!!errors.calibrationDate}>
              <InputField label="Calibration Date" id="calibrationDate" type="date" value={form.calibrationDate} onChange={handleChange} />
              {errors.calibrationDate && <FormErrorMessage>{errors.calibrationDate}</FormErrorMessage>}
            </FormControl>

            <FormControl isInvalid={!!errors.calibrationDueDate}>
              <InputField label="Calibration Due Date" id="calibrationDueDate" type="date" value={form.calibrationDueDate} onChange={handleChange} />
              {errors.calibrationDueDate && <FormErrorMessage>{errors.calibrationDueDate}</FormErrorMessage>}
            </FormControl>

            <FormControl isInvalid={!!errors.calibrationFrequency}>
              <Text fontSize="sm" fontWeight="bold" mb="8px">
                Calibration Frequency
              </Text>

              {form.calibrationFrequency === 'Custom' ? (
                <InputField
                  id="customFrequency"
                  value={form.customFrequency}
                  onChange={handleChange}
                  placeholder="Enter total no. of days (e.g. 45, 180)"
                  onBlur={() => {
                    if (!form.customFrequency.trim()) {
                      setForm(prev => ({
                        ...prev,
                        calibrationFrequency: '',
                        customFrequency: '',
                      }));
                    }
                  }}
                  h="44px"
                  fontSize="sm"
                  autoFocus
                />
              ) : (
                <Select
                  id="calibrationFrequency"
                  value={form.calibrationFrequency}
                  onChange={handleChange}
                  placeholder="Select Frequency"
                  h="44px"
                  fontSize="sm"
                  bg={inputBg}
                  color={textColor}
                  borderColor={inputBorderColor}
                >
                  <option style={{ backgroundColor: menuListBg, color: textColor }} value="Monthly">Monthly</option>
                  <option style={{ backgroundColor: menuListBg, color: textColor }} value="Quarterly">Quarterly</option>
                  <option style={{ backgroundColor: menuListBg, color: textColor }} value="Yearly">Yearly</option>
                  <option style={{ backgroundColor: menuListBg, color: textColor }} value="Custom">Custom</option>
                </Select>
              )}
              {(errors.calibrationFrequency || errors.customFrequency) && (<FormErrorMessage> {errors.calibrationFrequency || errors.customFrequency}</FormErrorMessage>)}
            </FormControl>
          
           

            <InputField label="Days To Expire" id="daysToExpire" value={form.daysToExpire} isReadOnly />

            {/* Status Dropdown */}
            {/* <FormControl>
              <Text mb="8px" fontWeight="500">Status</Text>
              <Select id="status" value={form.status} onChange={handleChange} placeholder="Select Status">
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </Select>
            </FormControl> */}

       <FormControl>
  <Text fontSize="sm" fontWeight="bold" mb="8px">
    No Of Certificates
  </Text>

  <Flex align="center" gap={2}>
    <Button
      size="sm"
      onClick={() =>
        setForm((prev) => ({
          ...prev,
          noOfCertificates: Math.max(
            0,
            Number(prev.noOfCertificates || 0) - 1
          ).toString(),
        }))
      }
      isDisabled={
        isEditMode ||
        Number(form.noOfCertificates || 0) <= 0
      }
    >
      -
    </Button>

    <InputField
      id="noOfCertificates"
      type="number"
      value={form.noOfCertificates}
      onChange={handleChange}
      inputProps={{
        min: 0,
        max: 10,
        style: { textAlign: "center" },
      }}
    />

   <Button
  size="sm"
  onClick={() =>
    setForm((prev) => ({
      ...prev,
      noOfCertificates: Math.min(
        10,
        Number(prev.noOfCertificates || 0) + 1
      ).toString(),
    }))
  }
  isDisabled={Number(form.noOfCertificates || 0) >= 10}
>
  +
</Button>
  </Flex>
</FormControl>
          </Grid>

          <Flex justify="center" mt={6} gap={4}>
            <Button variant="outline" onClick={handleReset}>
              Reset
            </Button>
            <Button type="submit" colorScheme="blue" isLoading={isSubmitting} isDisabled={isSubmitting}>
              {isEditMode ? 'Update' : 'Save'}
            </Button>
          </Flex>
        </form>
      </Card>
    </Flex>
  );
}
